import type { GracePhase } from "@/contexts/MaintenanceContext";

/**
 * Limiares da carência de sessão (Story 3.5) — espelham
 * GRACE_PHASE_WARN/SAVE/READONLY de
 * `app/services/maintenance_window_service.py` e os mesmos números já
 * usados em `CountdownTimer.tsx`. Um só lugar: `manutencaoTravada.ts` e
 * `MaintenanceProvider.tsx` (evento WS "active") precisam da MESMA conta.
 */
export const CARENCIA_LIMITE_WARN_SEGUNDOS = 60;
export const CARENCIA_LIMITE_SAVE_SEGUNDOS = 30;
export const CARENCIA_LIMITE_READONLY_SEGUNDOS = 10;

/** Fases válidas — "expired" (que o backend manda no /status quando a
 * carência já passou) NUNCA é uma fase de carência de verdade; vira `null`
 * antes de chegar aqui (ver `MaintenanceProvider.tsx`). */
export function calcularFaseDaCarencia(segundosRestantes: number): GracePhase {
  if (segundosRestantes <= 0) return null;
  if (segundosRestantes <= CARENCIA_LIMITE_READONLY_SEGUNDOS) return "logout";
  if (segundosRestantes <= CARENCIA_LIMITE_SAVE_SEGUNDOS) return "readonly";
  if (segundosRestantes <= CARENCIA_LIMITE_WARN_SEGUNDOS) return "save";
  return "warn";
}

/** `null` se não houver data, ou se a data vier inválida (mesmo tratamento
 * do backend: timestamp inválido não quebra, só não conta como carência). */
export function segundosRestantesAte(dataIso: string | null | undefined): number | null {
  if (!dataIso) return null;
  const alvo = new Date(dataIso).getTime();
  if (Number.isNaN(alvo)) return null;
  return (alvo - Date.now()) / 1000;
}

const FASES_VALIDAS_DE_CARENCIA: ReadonlySet<string> = new Set([
  "warn",
  "save",
  "readonly",
  "logout",
]);

/**
 * Achado MÉDIO (E2E, 28/09/2026, item 7): `GET /maintenance/status` manda
 * `phase: "expired"` quando a carência já passou — uma string que NÃO É
 * membro de `GracePhase`, mas um cast `as GracePhase` sem validação (como o
 * `MaintenanceProvider` fazia antes) deixa passar assim mesmo, e "expired" é
 * truthy em JS — o `MaintenanceOverlay`/modal de carência achava que ainda
 * havia carência em curso e aparecia por cima de TUDO (inclusive do login),
 * bloqueando cliques. Qualquer valor fora do union vira `null` aqui.
 */
export function normalizarFaseDaCarencia(valor: string | null | undefined): GracePhase {
  if (valor && FASES_VALIDAS_DE_CARENCIA.has(valor)) return valor as GracePhase;
  return null;
}
